<template>
<div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-bind:to="{ 'name': $i18n.locale + 'Settings' }">
            {{ $t('settings') }}
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ $t('profile') }}</li>
      </ol>
    </nav>
    <div class="container-fluid">
    <header class="page header">
      <div class="content">
        <h1 class="display-4 mb-0">{{ $t('profile') }}</h1>
        <p class="lead text-muted"></p>
      </div>
    </header>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(updateProfile)" class="pb-5">
          <div class="row">
            <div class="col-md-6 border-right">
              <h5>Osebni podatki</h5>

              <div class="form-group">
                <label>Ime</label>
                <ValidationProvider name="ime" v-slot="{ errors }" rules="required">
                  <input class="form-control" v-model="host.name.first" :class="{ 'is-invalid': errors[0] }">
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label>Priimek</label>
                <ValidationProvider name="priimek" v-slot="{ errors }" rules="required">
                  <input class="form-control" v-model="host.name.last" :class="{ 'is-invalid': errors[0] }">
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <hr>
              <h5>Kontaktni podatki</h5>

              <div class="form-group">
                <label>Email</label>
                <ValidationProvider name="email" v-slot="{ errors }" rules="required">
                  <input class="form-control" v-model="host.email" :class="{ 'is-invalid': errors[0] }">
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <label>Phone</label>
                <ValidationProvider name="phone" v-slot="{ errors }" rules="required">
                  <input class="form-control" v-model="host.phone" :class="{ 'is-invalid': errors[0] }">
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <hr>
              <h5>Naslov</h5>

              <div class="row">
                <div class="form-group col-md-10">
                  <label>Street Address</label>
                  <ValidationProvider name="address" v-slot="{ errors }" rules="required">
                    <input class="form-control" v-model="host.address.street" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group col-md-2">
                  <label>House Number</label>
                  <ValidationProvider name="house number" v-slot="{ errors }" rules="required">
                    <input class="form-control" v-model="host.address.number" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-4">
                  <label>Postal code</label>
                  <ValidationProvider name="postal code" v-slot="{ errors }" rules="required">
                    <input class="form-control" v-model="host.address.postalCode" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>

                <div class="form-group col-md-8">
                  <label>City</label>
                  <ValidationProvider name="city" v-slot="{ errors }" rules="required">
                    <input class="form-control" v-model="host.address.city" :class="{ 'is-invalid': errors[0] }">
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="form-group">
                <label>Country</label>
                <ValidationProvider name="countryr" v-slot="{ errors }" rules="required">
                  <select class="form-control" v-model="host.address.country" :class="{ 'is-invalid': errors[0] }">
                    <option disabled value=""></option>
                    <option v-for="country in countries" v-bind:value="country.code">{{country.name}}</option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

            </div>

            <div class="col-md-2 text-center">
              <div class="form-group">
                <img :src="$store.state.host.avatar || require('../../../assets/jumpstart/img/kljukica_zelena.svg')" alt="Avatar" class="user-avatar rounded-circle">
                <br>
                <label class="btn btn-sm btn-link" style="cursor:pointer;">
                  Spemeni avatar
                  <input type="file" hidden accept="image/*" @change="updateAvatar">
                </label>
              </div>
            </div>
          </div>

          <button class="btn btn-primary mt-3" type="submit">
            Shrani spremembe
          </button>

        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
const countryList = require('country-list');
const { cloneDeep } = require('lodash');

export default {
  name: 'Profile',
  data: () => ({
    'host': {
      '_id': '',
      'name': {
        'first': '',
        'last': ''
      },
      'email': '',
      'phone': '',
      'address': {
        'street': '',
        'number': '',
        'postalCode': '',
        'city': '',
        'country': ''
      },
      'avatar': ''
    },
    countries: countryList.getData()
  }),
  mounted() {
    this.host = cloneDeep(this.$store.state.host);
  },
  methods: {
    updateProfile: function(e){
      fetch( process.env.VUE_APP_API + '/hosts/' + this.host._id, {
        method : 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify(this.host)
      })
      .then(response => response.json())
      .then(response => {
        if(response.error) console.log(response.error);
        this.$store.commit('update', response);
      })
    },
    updateAvatar: function(e){
      const files = event.target.files;
      const formData = new FormData();
      formData.set('avatar', files[0]);
      formData.set('_id', this.host._id);

      fetch(process.env.VUE_APP_API + '/hosts/avatar', {
        method: 'post',
        credentials: 'include',
        headers: {
          'Accept': 'image/*',
          'CSRF-Token': this.$csrf
        },
        body: formData
      })
      .then(response => response.json())
      .then(response => {
        this.$store.commit('update', response);
        console.log(response);
      })

    }
  }
}
</script>

<i18n>
{
  "en": {
    "settings": "Settings",
    "profile": "Profile Settings"
  },
  "sl": {
    "settings": "Nastavitve",
    "profile": "Nastavitve Profila"
  }
}
</i18n>
